import { fetchAppShareCardFile } from '../../infrastructure/content/appShareCardFile';
import { resolveCanonicalOrigin } from '../i18n/localeDocumentMetadata';
import { SHARE_RESULTS, shareImage } from './shareImage';

/**
 * Share the app itself: the scenic card, in the language on screen, with the
 * locale's own address under it (SPEC-020).
 *
 * The counterpart to `sharePlantSheet.js`, over the same ladder in
 * `shareImage.js`. What is particular to this one is the ADDRESS.
 *
 * `window.location.href` is what the plant share sends, and it is wrong here for
 * two reasons. On a Firebase mirror or a preview channel it hands out an address
 * that is not the product's — `resolveCanonicalOrigin` exists for exactly that
 * and already names the three hostnames. And on the landing screen the current
 * href may carry a hash or a query the visitor never chose to send.
 *
 * So the shared address is the locale root off the canonical origin: the same
 * string `<link rel="canonical">` publishes for this screen, and the same one the
 * per-locale shell of D-4 is served at. Three facts, one source (D-6).
 */

export { SHARE_RESULTS };

export function appShareUrl(localeCode, locationObject) {
    return `${resolveCanonicalOrigin(locationObject)}/${localeCode}`;
}

export async function shareApp(
    { localeCode, languageCode, title, text },
    {
        nav = typeof navigator === 'undefined' ? null : navigator,
        loadFile = fetchAppShareCardFile,
        locationObject = typeof window === 'undefined' ? null : window.location,
    } = {},
) {
    return shareImage(
        { title, text, url: appShareUrl(localeCode, locationObject) },
        () => loadFile({ languageCode }),
        nav,
    );
}
